module.exports = __webpack_public_path__ + "static/media/phone.ee1d8ad1.png";